@if (field) {
  <mat-radio-group
    [formControlName]="field?.key"
    class="column-container"
    >
    @for (opt of field?.options; track opt) {
      <mat-radio-button
        [value]="opt.value"
        [(ngModel)]="selectedOption"
        (ngModelChange)="onSelectionChange()"
        [ngModelOptions]="{ standalone: true }"
        ngDefaultControl
        >{{ opt.label }}</mat-radio-button
        >
      }
    </mat-radio-group>
  }

  @if (controlContainer.control?.get(field?.key)?.hasError('required')) {
    <mat-error
      >Debe completar el campo.
    </mat-error>
  }
